export default {
  name: 'remote-deployment',
  translationKey: 'remote-deployment-module',
  routePrefix: 'remote-deployment',
  routeNamePrefix: 'remote-deployment',
  directRoutesAvailable: true,
}
